<ft-modal-overlay [open]="true">
  <div id="accountv2.TouchpointContainer" ft-ensure-modal-single-scroll>
    <div class="ft-touchpoint">
      <header class="ft-touchpoint-header">
        <button class="ft-btn-close" (click)="closeContainer()"></button>
        <div class="ft-modal-id">
          <h1 class="ft-modal-name ft-text-plus-3">{{ touchpointTitle() }}</h1>
          <ft-switch [hidden]="!showActivate()"
                     [state]="!!thc().isActive"
                     (stateChange)="thc().isActive = $event"
                     (change)="updateState()"
                     [disabledControl]="!thc().isEnabledControl" />
        </div>
      </header>
      <main class="ft-touchpoint-main">
        <!-- Gapless @for: v1 appended the inline-block <li> clones adjacently — with
             preserveWhitespaces:true block whitespace paints ~4px gaps between tabs. -->
        <nav class="ft-nav ft-navbar ft-sections-nav">
          <ul>@for (tab of supportedTabs(); track tab) {<li (click)="switchDataType(tab)"
                  [class.active]="isDataType(tab)"><a>{{ tab | capitalize }}</a></li>}</ul>
        </nav>
        <!-- 'tab-container' is a DOM contract the parity gate keys on
             ([id="accountv2.TouchpointContainer"] [tab-container] .ft-panel / .css-text /
             .editor-preview …) — it marked the v1 adapter's $compile mount target. Kept as
             a bare marker attribute (no behavior in Angular) so the native tab body renders
             inside [tab-container] exactly as v1 did. -->
        <section class="ft-master-section ft-touchpoint-master" tab-container>
          @if (ready()) {
            @switch (nativeTabKey()) {
              @case ('messaging') {
                <ft-touchpoint-messaging-ng [messaging]="injectables().messaging"
                                            [layerName]="injectables().layerName"
                                            [touchpointType]="injectables().touchpointType"
                                            [touchpointGroupId]="injectables().touchpointGroupId"
                                            [propertyUuid]="propertyUuid()" />
              }
              @case ('styling') {
                <ft-touchpoint-styling-ng [styling]="injectables().styling"
                                          [propertyImages]="injectables().propertyImages"
                                          [layerName]="injectables().layerName"
                                          [touchpointType]="injectables().touchpointType"
                                          [touchpointGroupId]="injectables().touchpointGroupId"
                                          [propertyUuid]="propertyUuid()" />
              }
              @case ('integration') {
                <ft-touchpoint-integration-ng [integration]="injectables().integration"
                                              [layerName]="injectables().layerName"
                                              [touchpointType]="injectables().touchpointType"
                                              [touchpointGroupId]="injectables().touchpointGroupId"
                                              [propertyUuid]="propertyUuid()" />
              }
              @case ('certificate-email') {
                <ft-touchpoint-certificate-email-ng [propertyUuid]="propertyUuid()"
                                                    [touchpointType]="injectables().touchpointType"
                                                    [emailTypes]="injectables().emailTypes" />
              }
              @case ('certificate-reminder-email') {
                <ft-touchpoint-certificate-reminder-email-ng [propertyUuid]="propertyUuid()"
                                                             [touchpointType]="injectables().touchpointType"
                                                             [emailTypes]="injectables().emailTypes" />
              }
            }
          }
        </section>
      </main>
    </div>
  </div>
</ft-modal-overlay>
